// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SentimentAnalysisTable_wrapper__3diLR"};